import ReportHashtag from '@/views/report-hashtag'
export default {
  path: 'report/report-hashtag',
  // redirect: '/report',
  name: 'Report Hashtag',
  component: ReportHashtag
}



// WEBPACK FOOTER //
// ./src/router/reports/report-hashtag.js